(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-mireia"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCollection() {
    var sortSelect = document.querySelector('[data-ms-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var openBtn = document.querySelector('[data-ms-filters-open]');
    var closeBtn = document.querySelector('[data-ms-filters-close]');
    var backdrop = document.querySelector('[data-ms-filters-backdrop]');
    var filters = document.querySelector('[data-ms-filters]');

    if (!filters) return;

    function openFilters() {
      filters.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.classList.add('ms-coll-filters-locked');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }

    function closeFilters() {
      filters.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('ms-coll-filters-locked');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }

    if (openBtn) {
      openBtn.addEventListener('click', function() {
        if (filters.classList.contains('is-open')) {
          closeFilters();
        } else {
          openFilters();
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (backdrop) backdrop.addEventListener('click', closeFilters);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && filters.classList.contains('is-open')) {
        closeFilters();
      }
    });

    var form = document.querySelector('[data-ms-filters-form]');
    if (form) {
      form.addEventListener('submit', function(e) {
        var inputs = form.querySelectorAll('input');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].type === 'number' && inputs[i].value === '') {
            inputs[i].disabled = true;
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollection);
  } else {
    initCollection();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-lote"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.ms-product');
  if (!sections.length) return;

  sections.forEach(section => initProduct(section));

  function initProduct(section) {
    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let productData;
    try {
      productData = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }

    const form = section.querySelector('[data-product-form]');
    const variantInput = section.querySelector('[data-variant-id]');
    const addBtn = section.querySelector('[data-add-btn]');
    const addLabel = section.querySelector('[data-add-label]');
    const priceCurrent = section.querySelector('[data-price-current]');
    const priceCompare = section.querySelector('[data-price-compare]');
    const klarnaAmount = section.querySelector('[data-klarna-amount]');
    const mainImage = section.querySelector('[data-main-image]');
    const mainImageWrap = section.querySelector('[data-main-image-wrap]');
    const thumbs = section.querySelectorAll('[data-thumb]');
    const qtyMinus = section.querySelector('[data-qty-minus]');
    const qtyPlus = section.querySelector('[data-qty-plus]');
    const qtyInput = section.querySelector('[data-qty-input]');
    const optionGroups = section.querySelectorAll('[data-option-group]');
    const lightbox = section.querySelector('[data-lightbox]');
    const lightboxImg = section.querySelector('[data-lightbox-img]');
    const lightboxClose = section.querySelector('[data-lightbox-close]');
    const metaPrice = section.querySelector('meta[itemprop="price"]');
    const metaAvail = section.querySelector('meta[itemprop="availability"]');
    const metaImage = section.querySelector('link[itemprop="image"]');

    const labels = {
      add: section.dataset.labelAdd,
      adding: section.dataset.labelAdding,
      added: section.dataset.labelAdded,
      soldout: section.dataset.labelSoldout
    };

    const currency = section.dataset.moneyCurrency || 'EUR';
    const moneyFormatter = new Intl.NumberFormat('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100) + ' €';
    }

    function getCurrentVariant() {
      const id = parseInt(variantInput.value, 10);
      return productData.variants.find(v => v.id === id);
    }

    function renderAddLabel(variant) {
      if (!variant) return;
      addLabel.textContent = '';
      const txt = document.createTextNode(labels.add + ' · ');
      const span = document.createElement('span');
      span.setAttribute('data-add-price', '');
      span.textContent = formatMoney(variant.price);
      addLabel.appendChild(txt);
      addLabel.appendChild(span);
    }

    function updateKlarna(variant) {
      if (!klarnaAmount || !variant) return;
      klarnaAmount.textContent = formatMoney(Math.round(variant.price / 3));
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (window.innerWidth < 1024) return;
        const src = thumb.dataset.fullSrc;
        const alt = thumb.dataset.fullAlt;
        if (mainImage && src) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = src;
          if (alt) mainImage.alt = alt;
        }
        thumbs.forEach(t => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }

    if (optionGroups.length) {
      const radios = section.querySelectorAll('[data-variant-option]');
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          const selected = [];
          optionGroups.forEach(group => {
            const checked = group.querySelector('input:checked');
            if (checked) selected.push(checked.value);
          });

          const matched = productData.variants.find(v => {
            if (v.options.length !== selected.length) return false;
            return v.options.every((opt, i) => opt === selected[i]);
          });

          if (!matched) return;

          variantInput.value = matched.id;

          if (priceCurrent) priceCurrent.textContent = formatMoney(matched.price);

          updateKlarna(matched);

          if (priceCompare) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
              priceCompare.textContent = formatMoney(matched.compare_at_price);
              priceCompare.removeAttribute('hidden');
            } else {
              priceCompare.setAttribute('hidden', '');
              priceCompare.textContent = '';
            }
          }

          if (matched.available) {
            addBtn.disabled = false;
            renderAddLabel(matched);
          } else {
            addBtn.disabled = true;
            addLabel.textContent = labels.soldout;
          }

          if (metaPrice) metaPrice.setAttribute('content', (matched.price / 100).toFixed(2));
          if (metaAvail) metaAvail.setAttribute('content', 'https://schema.org/' + (matched.available ? 'InStock' : 'OutOfStock'));

          if (matched.featured_image && matched.featured_image.src && mainImage) {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = matched.featured_image.src;
            if (metaImage) metaImage.setAttribute('href', matched.featured_image.src);
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    }

    if (form && addBtn) {
      form.addEventListener('submit', async (e) => {
        if (addBtn.disabled) {
          e.preventDefault();
          return;
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (!cart) {
          return;
        }

        e.preventDefault();

        const formData = new FormData(form);

        if (typeof cart.getSectionsToRender === 'function') {
          const sectionIds = cart.getSectionsToRender().map(s => s.id).join(',');
          formData.append('sections', sectionIds);
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement && cart.setActiveElement(document.activeElement);
        }

        addBtn.disabled = true;
        addLabel.textContent = labels.adding;

        try {
          const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Cart error');
          }

          const data = await res.json();

          addLabel.textContent = labels.added;

          if (typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else {
            cart.classList.remove('is-empty');
            if (typeof cart.open === 'function') cart.open(addBtn);
          }

          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          setTimeout(() => {
            addBtn.disabled = false;
            const v = getCurrentVariant();
            if (v && v.available) {
              renderAddLabel(v);
            } else {
              addLabel.textContent = labels.soldout;
              addBtn.disabled = true;
            }
          }, 1500);

        } catch (err) {
          addBtn.disabled = false;
          const v = getCurrentVariant();
          if (v && v.available) {
            renderAddLabel(v);
          } else {
            addLabel.textContent = labels.soldout;
            addBtn.disabled = true;
          }
        }
      });
    }

    if (mainImageWrap && lightbox && lightboxImg && mainImage) {
      mainImageWrap.addEventListener('click', () => {
        lightboxImg.src = mainImage.src;
        lightboxImg.alt = mainImage.alt || '';
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    }

    if (lightbox && lightboxClose) {
      const closeLightbox = () => {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      lightboxClose.addEventListener('click', closeLightbox);

      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') {
          closeLightbox();
        }
      });
    }
    const stickyBar = section.querySelector('[data-sticky-bar]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');

    if (stickyBar && stickyAdd && addBtn) {
      const actionsEl = section.querySelector('.ms-product__actions');
      if (actionsEl && 'IntersectionObserver' in window) {
        const obs = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.setAttribute('data-visible', visible ? 'true' : 'false');
            stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
          });
        }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
        obs.observe(actionsEl);
      }

      stickyAdd.addEventListener('click', () => {
        if (addBtn.disabled) return;
        if (typeof addBtn.scrollIntoView === 'function') {
          addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        setTimeout(() => addBtn.click(), 400);
      });
    }

    const fadeEls = section.querySelectorAll('[data-fade]');
    if (fadeEls.length && 'IntersectionObserver' in window) {
      const fadeObs = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            fadeObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      fadeEls.forEach(el => fadeObs.observe(el));
    } else {
      fadeEls.forEach(el => el.classList.add('is-visible'));
    }

    function updateStickyPrice(variant) {
      if (!stickyLabel || !variant) return;
      if (variant.available) {
        stickyLabel.textContent = '';
        const txt = document.createTextNode(labels.add + ' · ');
        const span = document.createElement('span');
        span.setAttribute('data-sticky-price', '');
        span.textContent = formatMoney(variant.price);
        stickyLabel.appendChild(txt);
        stickyLabel.appendChild(span);
        if (stickyAdd) stickyAdd.disabled = false;
      } else {
        stickyLabel.textContent = labels.soldout;
        if (stickyAdd) stickyAdd.disabled = true;
      }
    }

    if (optionGroups.length && stickyLabel) {
      section.querySelectorAll('[data-variant-option]').forEach(radio => {
        radio.addEventListener('change', () => {
          const v = getCurrentVariant();
          updateStickyPrice(v);
        });
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mireia"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.ms-product');
  if (!sections.length) return;

  sections.forEach(section => initProduct(section));

  function initProduct(section) {
    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let productData;
    try {
      productData = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }

    const form = section.querySelector('[data-product-form]');
    const variantInput = section.querySelector('[data-variant-id]');
    const addBtn = section.querySelector('[data-add-btn]');
    const addLabel = section.querySelector('[data-add-label]');
    const priceCurrent = section.querySelector('[data-price-current]');
    const priceCompare = section.querySelector('[data-price-compare]');
    const mainImage = section.querySelector('[data-main-image]');
    const mainImageWrap = section.querySelector('[data-main-image-wrap]');
    const thumbs = section.querySelectorAll('[data-thumb]');
    const qtyMinus = section.querySelector('[data-qty-minus]');
    const qtyPlus = section.querySelector('[data-qty-plus]');
    const qtyInput = section.querySelector('[data-qty-input]');
    const optionGroups = section.querySelectorAll('[data-option-group]');
    const lightbox = section.querySelector('[data-lightbox]');
    const lightboxImg = section.querySelector('[data-lightbox-img]');
    const lightboxClose = section.querySelector('[data-lightbox-close]');
    const metaPrice = section.querySelector('meta[itemprop="price"]');
    const metaAvail = section.querySelector('meta[itemprop="availability"]');
    const metaImage = section.querySelector('link[itemprop="image"]');

    const labels = {
      add: section.dataset.labelAdd,
      adding: section.dataset.labelAdding,
      added: section.dataset.labelAdded,
      soldout: section.dataset.labelSoldout
    };

    const currency = section.dataset.moneyCurrency || 'EUR';
    const moneyFormatter = new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: currency
    });

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100);
    }

    function getCurrentVariant() {
      const id = parseInt(variantInput.value, 10);
      return productData.variants.find(v => v.id === id);
    }

    function renderAddLabel(variant) {
      if (!variant) return;
      addLabel.textContent = '';
      const txt = document.createTextNode(labels.add + ' · ');
      const span = document.createElement('span');
      span.setAttribute('data-add-price', '');
      span.textContent = formatMoney(variant.price);
      addLabel.appendChild(txt);
      addLabel.appendChild(span);
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (window.innerWidth < 1024) return;
        const src = thumb.dataset.fullSrc;
        const alt = thumb.dataset.fullAlt;
        if (mainImage && src) {
          mainImage.src = src;
          if (alt) mainImage.alt = alt;
        }
        thumbs.forEach(t => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }

    if (optionGroups.length) {
      const radios = section.querySelectorAll('[data-variant-option]');
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          const selected = [];
          optionGroups.forEach(group => {
            const checked = group.querySelector('input:checked');
            if (checked) selected.push(checked.value);
          });

          const matched = productData.variants.find(v => {
            if (v.options.length !== selected.length) return false;
            return v.options.every((opt, i) => opt === selected[i]);
          });

          if (!matched) return;

          variantInput.value = matched.id;

          if (priceCurrent) priceCurrent.textContent = formatMoney(matched.price);

          if (priceCompare) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
              priceCompare.textContent = formatMoney(matched.compare_at_price);
              priceCompare.removeAttribute('hidden');
            } else {
              priceCompare.setAttribute('hidden', '');
              priceCompare.textContent = '';
            }
          }

          if (matched.available) {
            addBtn.disabled = false;
            renderAddLabel(matched);
          } else {
            addBtn.disabled = true;
            addLabel.textContent = labels.soldout;
          }

          if (metaPrice) metaPrice.setAttribute('content', (matched.price / 100).toFixed(2));
          if (metaAvail) metaAvail.setAttribute('content', 'https://schema.org/' + (matched.available ? 'InStock' : 'OutOfStock'));

          if (matched.featured_image && matched.featured_image.src && mainImage) {
            mainImage.src = matched.featured_image.src;
            if (metaImage) metaImage.setAttribute('href', matched.featured_image.src);
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    }

    if (form && addBtn) {
      form.addEventListener('submit', async (e) => {
        if (addBtn.disabled) {
          e.preventDefault();
          return;
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (!cart) {
          return;
        }

        e.preventDefault();

        const formData = new FormData(form);

        if (typeof cart.getSectionsToRender === 'function') {
          const sectionIds = cart.getSectionsToRender().map(s => s.id).join(',');
          formData.append('sections', sectionIds);
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement && cart.setActiveElement(document.activeElement);
        }

        addBtn.disabled = true;
        addLabel.textContent = labels.adding;

        try {
          const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Cart error');
          }

          const data = await res.json();

          addLabel.textContent = labels.added;

          if (typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else {
            cart.classList.remove('is-empty');
            if (typeof cart.open === 'function') cart.open(addBtn);
          }

          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          setTimeout(() => {
            addBtn.disabled = false;
            const v = getCurrentVariant();
            if (v && v.available) {
              renderAddLabel(v);
            } else {
              addLabel.textContent = labels.soldout;
              addBtn.disabled = true;
            }
          }, 1500);

        } catch (err) {
          addBtn.disabled = false;
          const v = getCurrentVariant();
          if (v && v.available) {
            renderAddLabel(v);
          } else {
            addLabel.textContent = labels.soldout;
            addBtn.disabled = true;
          }
        }
      });
    }

    if (mainImageWrap && lightbox && lightboxImg && mainImage) {
      mainImageWrap.addEventListener('click', () => {
        lightboxImg.src = mainImage.src;
        lightboxImg.alt = mainImage.alt || '';
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    }

    if (lightbox && lightboxClose) {
      const closeLightbox = () => {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      lightboxClose.addEventListener('click', closeLightbox);

      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') {
          closeLightbox();
        }
      });
    }
    const stickyBar = section.querySelector('[data-sticky-bar]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');

    if (stickyBar && stickyAdd && addBtn) {
      const actionsEl = section.querySelector('.ms-product__actions');
      if (actionsEl && 'IntersectionObserver' in window) {
        const obs = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.setAttribute('data-visible', visible ? 'true' : 'false');
            stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
          });
        }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
        obs.observe(actionsEl);
      }

      stickyAdd.addEventListener('click', () => {
        if (addBtn.disabled) return;
        if (typeof addBtn.scrollIntoView === 'function') {
          addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        setTimeout(() => addBtn.click(), 400);
      });
    }

    const fadeEls = section.querySelectorAll('[data-fade]');
    if (fadeEls.length && 'IntersectionObserver' in window) {
      const fadeObs = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            fadeObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      fadeEls.forEach(el => fadeObs.observe(el));
    } else {
      fadeEls.forEach(el => el.classList.add('is-visible'));
    }

    function updateStickyPrice(variant) {
      if (!stickyLabel || !variant) return;
      if (variant.available) {
        stickyLabel.textContent = '';
        const txt = document.createTextNode(labels.add + ' · ');
        const span = document.createElement('span');
        span.setAttribute('data-sticky-price', '');
        span.textContent = formatMoney(variant.price);
        stickyLabel.appendChild(txt);
        stickyLabel.appendChild(span);
        if (stickyAdd) stickyAdd.disabled = false;
      } else {
        stickyLabel.textContent = labels.soldout;
        if (stickyAdd) stickyAdd.disabled = true;
      }
    }

    if (optionGroups.length && stickyLabel) {
      section.querySelectorAll('[data-variant-option]').forEach(radio => {
        radio.addEventListener('change', () => {
          const v = getCurrentVariant();
          updateStickyPrice(v);
        });
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-pieza"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.ms-product');
  if (!sections.length) return;

  sections.forEach(section => initProduct(section));

  function initProduct(section) {
    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let productData;
    try {
      productData = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }

    const form = section.querySelector('[data-product-form]');
    const variantInput = section.querySelector('[data-variant-id]');
    const addBtn = section.querySelector('[data-add-btn]');
    const addLabel = section.querySelector('[data-add-label]');
    const priceCurrent = section.querySelector('[data-price-current]');
    const priceCompare = section.querySelector('[data-price-compare]');
    const klarnaAmount = section.querySelector('[data-klarna-amount]');
    const mainImage = section.querySelector('[data-main-image]');
    const mainImageWrap = section.querySelector('[data-main-image-wrap]');
    const thumbs = section.querySelectorAll('[data-thumb]');
    const qtyMinus = section.querySelector('[data-qty-minus]');
    const qtyPlus = section.querySelector('[data-qty-plus]');
    const qtyInput = section.querySelector('[data-qty-input]');
    const optionGroups = section.querySelectorAll('[data-option-group]');
    const lightbox = section.querySelector('[data-lightbox]');
    const lightboxImg = section.querySelector('[data-lightbox-img]');
    const lightboxClose = section.querySelector('[data-lightbox-close]');
    const metaPrice = section.querySelector('meta[itemprop="price"]');
    const metaAvail = section.querySelector('meta[itemprop="availability"]');
    const metaImage = section.querySelector('link[itemprop="image"]');

    const labels = {
      add: section.dataset.labelAdd,
      adding: section.dataset.labelAdding,
      added: section.dataset.labelAdded,
      soldout: section.dataset.labelSoldout
    };

    const currency = section.dataset.moneyCurrency || 'EUR';
    const moneyFormatter = new Intl.NumberFormat('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100) + ' €';
    }

    function getCurrentVariant() {
      const id = parseInt(variantInput.value, 10);
      return productData.variants.find(v => v.id === id);
    }

    function renderAddLabel(variant) {
      if (!variant) return;
      addLabel.textContent = '';
      const txt = document.createTextNode(labels.add + ' · ');
      const span = document.createElement('span');
      span.setAttribute('data-add-price', '');
      span.textContent = formatMoney(variant.price);
      addLabel.appendChild(txt);
      addLabel.appendChild(span);
    }

    function updateKlarna(variant) {
      if (!klarnaAmount || !variant) return;
      klarnaAmount.textContent = formatMoney(Math.round(variant.price / 3));
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (window.innerWidth < 1024) return;
        const src = thumb.dataset.fullSrc;
        const alt = thumb.dataset.fullAlt;
        if (mainImage && src) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = src;
          if (alt) mainImage.alt = alt;
        }
        thumbs.forEach(t => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }

    if (optionGroups.length) {
      const radios = section.querySelectorAll('[data-variant-option]');
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          const selected = [];
          optionGroups.forEach(group => {
            const checked = group.querySelector('input:checked');
            if (checked) selected.push(checked.value);
          });

          const matched = productData.variants.find(v => {
            if (v.options.length !== selected.length) return false;
            return v.options.every((opt, i) => opt === selected[i]);
          });

          if (!matched) return;

          variantInput.value = matched.id;

          if (priceCurrent) priceCurrent.textContent = formatMoney(matched.price);

          updateKlarna(matched);

          if (priceCompare) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
              priceCompare.textContent = formatMoney(matched.compare_at_price);
              priceCompare.removeAttribute('hidden');
            } else {
              priceCompare.setAttribute('hidden', '');
              priceCompare.textContent = '';
            }
          }

          if (matched.available) {
            addBtn.disabled = false;
            renderAddLabel(matched);
          } else {
            addBtn.disabled = true;
            addLabel.textContent = labels.soldout;
          }

          if (metaPrice) metaPrice.setAttribute('content', (matched.price / 100).toFixed(2));
          if (metaAvail) metaAvail.setAttribute('content', 'https://schema.org/' + (matched.available ? 'InStock' : 'OutOfStock'));

          if (matched.featured_image && matched.featured_image.src && mainImage) {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = matched.featured_image.src;
            if (metaImage) metaImage.setAttribute('href', matched.featured_image.src);
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    }

    if (form && addBtn) {
      form.addEventListener('submit', async (e) => {
        if (addBtn.disabled) {
          e.preventDefault();
          return;
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (!cart) {
          return;
        }

        e.preventDefault();

        const formData = new FormData(form);

        if (typeof cart.getSectionsToRender === 'function') {
          const sectionIds = cart.getSectionsToRender().map(s => s.id).join(',');
          formData.append('sections', sectionIds);
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement && cart.setActiveElement(document.activeElement);
        }

        addBtn.disabled = true;
        addLabel.textContent = labels.adding;

        try {
          const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Cart error');
          }

          const data = await res.json();

          addLabel.textContent = labels.added;

          if (typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else {
            cart.classList.remove('is-empty');
            if (typeof cart.open === 'function') cart.open(addBtn);
          }

          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          setTimeout(() => {
            addBtn.disabled = false;
            const v = getCurrentVariant();
            if (v && v.available) {
              renderAddLabel(v);
            } else {
              addLabel.textContent = labels.soldout;
              addBtn.disabled = true;
            }
          }, 1500);

        } catch (err) {
          addBtn.disabled = false;
          const v = getCurrentVariant();
          if (v && v.available) {
            renderAddLabel(v);
          } else {
            addLabel.textContent = labels.soldout;
            addBtn.disabled = true;
          }
        }
      });
    }

    if (mainImageWrap && lightbox && lightboxImg && mainImage) {
      mainImageWrap.addEventListener('click', () => {
        lightboxImg.src = mainImage.src;
        lightboxImg.alt = mainImage.alt || '';
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    }

    if (lightbox && lightboxClose) {
      const closeLightbox = () => {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      lightboxClose.addEventListener('click', closeLightbox);

      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') {
          closeLightbox();
        }
      });
    }
    const stickyBar = section.querySelector('[data-sticky-bar]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');

    if (stickyBar && stickyAdd && addBtn) {
      const actionsEl = section.querySelector('.ms-product__actions');
      if (actionsEl && 'IntersectionObserver' in window) {
        const obs = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.setAttribute('data-visible', visible ? 'true' : 'false');
            stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
          });
        }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
        obs.observe(actionsEl);
      }

      stickyAdd.addEventListener('click', () => {
        if (addBtn.disabled) return;
        if (typeof addBtn.scrollIntoView === 'function') {
          addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        setTimeout(() => addBtn.click(), 400);
      });
    }

    const fadeEls = section.querySelectorAll('[data-fade]');
    if (fadeEls.length && 'IntersectionObserver' in window) {
      const fadeObs = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            fadeObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      fadeEls.forEach(el => fadeObs.observe(el));
    } else {
      fadeEls.forEach(el => el.classList.add('is-visible'));
    }

    function updateStickyPrice(variant) {
      if (!stickyLabel || !variant) return;
      if (variant.available) {
        stickyLabel.textContent = '';
        const txt = document.createTextNode(labels.add + ' · ');
        const span = document.createElement('span');
        span.setAttribute('data-sticky-price', '');
        span.textContent = formatMoney(variant.price);
        stickyLabel.appendChild(txt);
        stickyLabel.appendChild(span);
        if (stickyAdd) stickyAdd.disabled = false;
      } else {
        stickyLabel.textContent = labels.soldout;
        if (stickyAdd) stickyAdd.disabled = true;
      }
    }

    if (optionGroups.length && stickyLabel) {
      section.querySelectorAll('[data-variant-option]').forEach(radio => {
        radio.addEventListener('change', () => {
          const v = getCurrentVariant();
          updateStickyPrice(v);
        });
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-sobre"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.ms-product');
  if (!sections.length) return;

  sections.forEach(section => initProduct(section));

  function initProduct(section) {
    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let productData;
    try {
      productData = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }

    const form = section.querySelector('[data-product-form]');
    const variantInput = section.querySelector('[data-variant-id]');
    const addBtn = section.querySelector('[data-add-btn]');
    const addLabel = section.querySelector('[data-add-label]');
    const priceCurrent = section.querySelector('[data-price-current]');
    const priceCompare = section.querySelector('[data-price-compare]');
    const klarnaAmount = section.querySelector('[data-klarna-amount]');
    const mainImage = section.querySelector('[data-main-image]');
    const mainImageWrap = section.querySelector('[data-main-image-wrap]');
    const thumbs = section.querySelectorAll('[data-thumb]');
    const qtyMinus = section.querySelector('[data-qty-minus]');
    const qtyPlus = section.querySelector('[data-qty-plus]');
    const qtyInput = section.querySelector('[data-qty-input]');
    const optionGroups = section.querySelectorAll('[data-option-group]');
    const lightbox = section.querySelector('[data-lightbox]');
    const lightboxImg = section.querySelector('[data-lightbox-img]');
    const lightboxClose = section.querySelector('[data-lightbox-close]');
    const metaPrice = section.querySelector('meta[itemprop="price"]');
    const metaAvail = section.querySelector('meta[itemprop="availability"]');
    const metaImage = section.querySelector('link[itemprop="image"]');

    const labels = {
      add: section.dataset.labelAdd,
      adding: section.dataset.labelAdding,
      added: section.dataset.labelAdded,
      soldout: section.dataset.labelSoldout
    };

    const currency = section.dataset.moneyCurrency || 'EUR';
    const moneyFormatter = new Intl.NumberFormat('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100) + ' €';
    }

    function getCurrentVariant() {
      const id = parseInt(variantInput.value, 10);
      return productData.variants.find(v => v.id === id);
    }

    function renderAddLabel(variant) {
      if (!variant) return;
      addLabel.textContent = '';
      const txt = document.createTextNode(labels.add + ' \u00B7 ');
      const span = document.createElement('span');
      span.setAttribute('data-add-price', '');
      span.textContent = formatMoney(variant.price);
      addLabel.appendChild(txt);
      addLabel.appendChild(span);
    }

    function updateKlarna(variant) {
      if (!klarnaAmount || !variant) return;
      klarnaAmount.textContent = formatMoney(Math.round(variant.price / 3));
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (window.innerWidth < 1024) return;
        const src = thumb.dataset.fullSrc;
        const alt = thumb.dataset.fullAlt;
        if (mainImage && src) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = src;
          if (alt) mainImage.alt = alt;
        }
        thumbs.forEach(t => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }

    if (optionGroups.length) {
      const radios = section.querySelectorAll('[data-variant-option]');
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          const selected = [];
          optionGroups.forEach(group => {
            const checked = group.querySelector('input:checked');
            if (checked) selected.push(checked.value);
          });

          const matched = productData.variants.find(v => {
            if (v.options.length !== selected.length) return false;
            return v.options.every((opt, i) => opt === selected[i]);
          });

          if (!matched) return;

          variantInput.value = matched.id;

          if (priceCurrent) priceCurrent.textContent = formatMoney(matched.price);

          updateKlarna(matched);

          if (priceCompare) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
              priceCompare.textContent = formatMoney(matched.compare_at_price);
              priceCompare.removeAttribute('hidden');
            } else {
              priceCompare.setAttribute('hidden', '');
              priceCompare.textContent = '';
            }
          }

          if (matched.available) {
            addBtn.disabled = false;
            renderAddLabel(matched);
          } else {
            addBtn.disabled = true;
            addLabel.textContent = labels.soldout;
          }

          if (metaPrice) metaPrice.setAttribute('content', (matched.price / 100).toFixed(2));
          if (metaAvail) metaAvail.setAttribute('content', 'https://schema.org/' + (matched.available ? 'InStock' : 'OutOfStock'));

          if (matched.featured_image && matched.featured_image.src && mainImage) {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = matched.featured_image.src;
            if (metaImage) metaImage.setAttribute('href', matched.featured_image.src);
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    }

    if (form && addBtn) {
      form.addEventListener('submit', async (e) => {
        if (addBtn.disabled) {
          e.preventDefault();
          return;
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (!cart) {
          return;
        }

        e.preventDefault();

        const formData = new FormData(form);

        if (typeof cart.getSectionsToRender === 'function') {
          const sectionIds = cart.getSectionsToRender().map(s => s.id).join(',');
          formData.append('sections', sectionIds);
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement && cart.setActiveElement(document.activeElement);
        }

        addBtn.disabled = true;
        addLabel.textContent = labels.adding;

        try {
          const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Cart error');
          }

          const data = await res.json();

          addLabel.textContent = labels.added;

          if (typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else {
            cart.classList.remove('is-empty');
            if (typeof cart.open === 'function') cart.open(addBtn);
          }

          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          setTimeout(() => {
            addBtn.disabled = false;
            const v = getCurrentVariant();
            if (v && v.available) {
              renderAddLabel(v);
            } else {
              addLabel.textContent = labels.soldout;
              addBtn.disabled = true;
            }
          }, 1500);

        } catch (err) {
          addBtn.disabled = false;
          const v = getCurrentVariant();
          if (v && v.available) {
            renderAddLabel(v);
          } else {
            addLabel.textContent = labels.soldout;
            addBtn.disabled = true;
          }
        }
      });
    }

    if (mainImageWrap && lightbox && lightboxImg && mainImage) {
      mainImageWrap.addEventListener('click', () => {
        lightboxImg.src = mainImage.src;
        lightboxImg.alt = mainImage.alt || '';
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    }

    if (lightbox && lightboxClose) {
      const closeLightbox = () => {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      lightboxClose.addEventListener('click', closeLightbox);

      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') {
          closeLightbox();
        }
      });
    }
    const stickyBar = section.querySelector('[data-sticky-bar]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');

    if (stickyBar && stickyAdd && addBtn) {
      const actionsEl = section.querySelector('.ms-product__actions');
      if (actionsEl && 'IntersectionObserver' in window) {
        const obs = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.setAttribute('data-visible', visible ? 'true' : 'false');
            stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
          });
        }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
        obs.observe(actionsEl);
      }

      stickyAdd.addEventListener('click', () => {
        if (addBtn.disabled) return;
        if (typeof addBtn.scrollIntoView === 'function') {
          addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        setTimeout(() => addBtn.click(), 400);
      });
    }

    const fadeEls = section.querySelectorAll('[data-fade]');
    if (fadeEls.length && 'IntersectionObserver' in window) {
      const fadeObs = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            fadeObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      fadeEls.forEach(el => fadeObs.observe(el));
    } else {
      fadeEls.forEach(el => el.classList.add('is-visible'));
    }

    function updateStickyPrice(variant) {
      if (!stickyLabel || !variant) return;
      if (variant.available) {
        stickyLabel.textContent = '';
        const txt = document.createTextNode(labels.add + ' \u00B7 ');
        const span = document.createElement('span');
        span.setAttribute('data-sticky-price', '');
        span.textContent = formatMoney(variant.price);
        stickyLabel.appendChild(txt);
        stickyLabel.appendChild(span);
        if (stickyAdd) stickyAdd.disabled = false;
      } else {
        stickyLabel.textContent = labels.soldout;
        if (stickyAdd) stickyAdd.disabled = true;
      }
    }

    if (optionGroups.length && stickyLabel) {
      section.querySelectorAll('[data-variant-option]').forEach(radio => {
        radio.addEventListener('change', () => {
          const v = getCurrentVariant();
          updateStickyPrice(v);
        });
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-mireia"] && !Shopify.designMode) return;
  try {
    
(function() {
  function resizeShopifyImage(url, width) {
    if (!url) return '';
    var clean = url.split('?')[0];
    var resized = clean.replace(/\.(jpg|jpeg|png|gif|webp)$/i, '_' + width + 'x.$1');
    return resized;
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str).replace(/[&<>"']/g, function(c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function buildCardHTML(p, position, fmt) {
    var imgUrl = '';
    var imgAlt = p.title || '';

    if (typeof p.featured_image === 'string') {
      imgUrl = p.featured_image;
    } else if (p.featured_image && p.featured_image.src) {
      imgUrl = p.featured_image.src;
      imgAlt = p.featured_image.alt || imgAlt;
    } else if (p.images && p.images.length > 0) {
      imgUrl = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
    }

    var imgSrc = imgUrl ? resizeShopifyImage(imgUrl, 600) : '';
    var imgSrc300 = imgUrl ? resizeShopifyImage(imgUrl, 300) : '';
    var imgSrc900 = imgUrl ? resizeShopifyImage(imgUrl, 900) : '';

    var priceVal = parseFloat(p.price_min != null ? p.price_min : p.price);
    var compareVal = parseFloat(p.compare_at_price_min != null ? p.compare_at_price_min : p.compare_at_price);
    if (isNaN(priceVal)) priceVal = 0;
    if (isNaN(compareVal)) compareVal = 0;
    priceVal = priceVal / 100;
    compareVal = compareVal / 100;

    var priceFormatted = fmt.format(priceVal);
    var hasCompare = compareVal > priceVal;
    var compareFormatted = hasCompare ? fmt.format(compareVal) : '';

    var html = '<li class="ms-recos__card" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">';
    html += '<meta itemprop="position" content="' + position + '">';
    html += '<a href="' + escapeHtml(p.url) + '" itemprop="url" class="ms-recos__link" aria-label="' + escapeHtml(p.title) + '">';
    html += '<div class="ms-recos__image-wrap">';
    if (imgSrc) {
      html += '<img src="' + escapeHtml(imgSrc) + '"';
      html += ' srcset="' + escapeHtml(imgSrc300) + ' 300w, ' + escapeHtml(imgSrc) + ' 600w, ' + escapeHtml(imgSrc900) + ' 900w"';
      html += ' sizes="(min-width: 1024px) 25vw, 70vw"';
      html += ' alt="' + escapeHtml(imgAlt) + '"';
      html += ' loading="lazy" decoding="async" width="600" height="600" class="ms-recos__image">';
    } else {
      html += '<div class="ms-recos__image-empty" aria-hidden="true"></div>';
    }
    html += '<span class="ms-recos__overlay" aria-hidden="true"><span class="ms-recos__cta">Ver pieza</span></span>';
    html += '</div>';
    html += '<div class="ms-recos__meta">';
    html += '<span class="ms-recos__name" itemprop="name">' + escapeHtml(p.title) + '</span>';
    html += '<span class="ms-recos__price">';
    if (hasCompare) {
      html += '<span class="ms-recos__price-now">' + priceFormatted + '</span>';
      html += '<span class="ms-recos__price-was">' + compareFormatted + '</span>';
    } else {
      html += priceFormatted;
    }
    html += '</span>';
    html += '</div>';
    html += '</a>';
    html += '</li>';
    return html;
  }

  function renderRecos(grid, products, max) {
    var fmt;
    try {
      fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      fmt = { format: function(v) { return v.toFixed(2).replace('.', ',') + ' €'; } };
    }

    var slice = products.slice(0, max);
    var html = '';
    for (var i = 0; i < slice.length; i++) {
      html += buildCardHTML(slice[i], i + 1, fmt);
    }
    grid.innerHTML = html;
  }

  function initReco(root) {
    if (root.dataset.hasManual === 'true') return;

    var productId = root.dataset.productId;
    var max = parseInt(root.dataset.max, 10) || 4;
    var grid = root.querySelector('[data-ms-recos-grid]');
    if (!grid || !productId) return;

    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + max + '&intent=related';

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(res) {
        if (!res.ok) throw new Error('reco fetch failed');
        return res.json();
      })
      .then(function(data) {
        if (!data || !Array.isArray(data.products) || data.products.length === 0) return;
        renderRecos(grid, data.products, max);
      })
      .catch(function() {});
  }

  function bootstrap() {
    var roots = document.querySelectorAll('[data-ms-recos]');
    for (var i = 0; i < roots.length; i++) {
      initReco(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
